/**
 * LAVELLE DEMO ENGINE
 * Handles Cart, Wishlist, and Search for frontend demo products.
 */

const DEMO_PRODUCTS = [
  { id: 'd1', title: 'White Serenity Halter Top', price: '�180.00', img: 'bikini-super-1.jpg' },
  { id: 'd2', title: 'Olive Contour Triangle Top', price: '�165.00', img: 'bikini-super-2.jpg' },
  { id: 'd3', title: 'Ocean Blue Wraparound Set', price: '�190.00', img: 'bikini-super-3.jpg' },
  { id: 'd4', title: 'Midnight Black Micro Set', price: '�175.00', img: 'bikini-super-4.jpg' },
  { id: 'd5', title: 'Amalfi Classic Two-Piece Bikini Set', price: '�175.00', img: 'bikini-super-5.jpg' }
];

// --- CART LOGIC ---
function getDemoCart() {
  return JSON.parse(localStorage.getItem('lavelle_cart') || '[]');
}
function saveDemoCart(cart) {
  localStorage.setItem('lavelle_cart', JSON.stringify(cart));
  updateCartUI();
}

window.addToDemoCart = function() {
  const title = document.getElementById('spa-title').innerText;
  const priceStr = document.getElementById('spa-price').innerText;
  const img = document.getElementById('spa-main-img').src;
  
  let size = 'S';
  const activeSizeBtn = document.querySelector('.spa-size-btn.active');
  if(activeSizeBtn) size = activeSizeBtn.innerText;

  const cart = getDemoCart();
  const existingItem = cart.find(item => item.title === title && item.size === size);
  if(existingItem) {
    existingItem.qty += 1;
  } else {
    cart.push({ id: Date.now(), title, price: priceStr, img, size, qty: 1 });
  }
  saveDemoCart(cart);
  
  if(typeof closeSpaPDP === 'function') closeSpaPDP();
  if(typeof openCartDrawer === 'function') openCartDrawer();
}

function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if(drawer) drawer.classList.add('active');
}

window.updateCartUI = function() {
  const cart = getDemoCart();
  const count = cart.reduce((sum, item) => sum + item.qty, 0);
  
  document.querySelectorAll('.cart-count-bubble').forEach(el => {
    el.innerText = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });

  const drawerItems = document.getElementById('demo-cart-items');
  const drawerTotal = document.getElementById('demo-cart-total');
  
  if (drawerItems) {
    if (cart.length === 0) {
      drawerItems.innerHTML = '<p style="text-align:center; padding: 2rem 0;">Your bag is empty.</p>';
      if(drawerTotal) drawerTotal.innerText = '�0.00';
    } else {
      let html = '';
      let total = 0;
      cart.forEach((item, index) => {
        const pNum = parseFloat(item.price.replace(/[^0-9.]/g, ''));
        total += (pNum * item.qty);
        html += `
          <div style="display: flex; gap: 1rem; margin-bottom: 1.5rem; padding-bottom: 1rem; border-bottom: 1px solid #eee;">
            <img src="${item.img}" style="width: 80px; height: 100px; object-fit: cover; border-radius: 4px;">
            <div style="flex: 1;">
              <h4 style="margin: 0 0 0.2rem; font-size: 0.9rem; color: #2D162C;">${item.title}</h4>
              <p style="margin: 0 0 0.5rem; font-size: 0.8rem; color: #666;">Size: ${item.size}</p>
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div style="display: flex; border: 1px solid #ccc; border-radius: 4px; overflow: hidden;">
                  <button onclick="updateDemoQty(${index}, -1)" style="border: none; background: #fff; padding: 0.2rem 0.6rem; cursor: pointer;">-</button>
                  <span style="padding: 0.2rem 0.6rem; font-size: 0.85rem; border-left: 1px solid #ccc; border-right: 1px solid #ccc;">${item.qty}</span>
                  <button onclick="updateDemoQty(${index}, 1)" style="border: none; background: #fff; padding: 0.2rem 0.6rem; cursor: pointer;">+</button>
                </div>
                <span style="font-weight: bold; color: #2D162C;">${item.price}</span>
              </div>
            </div>
          </div>
        `;
      });
      drawerItems.innerHTML = html;
      if(drawerTotal) drawerTotal.innerText = '�' + total.toFixed(2);
    }
  }
}

window.updateDemoQty = function(index, delta) {
  const cart = getDemoCart();
  if (cart[index]) {
    cart[index].qty += delta;
    if (cart[index].qty <= 0) cart.splice(index, 1);
    saveDemoCart(cart);
  }
}

window.demoCheckout = function() {
  const cart = getDemoCart();
  if(cart.length === 0) return alert("Your bag is empty!");
  alert("Checkout is currently in Demo Mode. Real payments are disabled.");
}

// --- WISHLIST LOGIC ---
function getWishlist() {
  return JSON.parse(localStorage.getItem('lavelle_wishlist') || '[]');
}

window.toggleDemoWishlist = function(event, title, price, img) {
  if(event) { event.preventDefault(); event.stopPropagation(); }
  let list = getWishlist();
  const exists = list.findIndex(item => item.title === title);
  
  if (exists > -1) {
    list.splice(exists, 1);
    alert('Removed from Favorites');
  } else {
    list.push({ title, price, img });
    alert('Added to Favorites');
  }
  localStorage.setItem('lavelle_wishlist', JSON.stringify(list));
  updateWishlistUI();
}

window.updateWishlistUI = function() {
  const list = getWishlist();
  const container = document.getElementById('demo-wishlist-grid');
  if(container) {
    if(list.length === 0) {
      container.innerHTML = '<p style="text-align:center; width:100%; grid-column: 1 / -1;">No favorites yet.</p>';
    } else {
      let html = '';
      list.forEach(item => {
        html += `
          <div style="text-align: center; border: 1px solid #EAE4EF; padding: 1rem; border-radius: 8px;">
            <img src="${item.img}" style="width: 100%; height: 250px; object-fit: cover; border-radius: 4px; margin-bottom: 1rem;">
            <h3 style="font-size: 1rem; color: #2D162C; margin-bottom: 0.5rem;">${item.title}</h3>
            <p style="font-weight: bold; margin-bottom: 1rem;">${item.price}</p>
            <button onclick="openSpaPDP(null, '${item.title.replace(/'/g, "\\'")}', '${item.price}', '', '${item.img}')" style="background: #2D162C; color: #fff; border: none; padding: 0.5rem 1rem; width: 100%; cursor: pointer; border-radius: 4px;">View Product</button>
            <button onclick="toggleDemoWishlist(null, '${item.title.replace(/'/g, "\\'")}', '${item.price}', '${item.img}')" style="background: transparent; color: #D32F2F; border: 1px solid #D32F2F; padding: 0.5rem 1rem; width: 100%; cursor: pointer; border-radius: 4px; margin-top: 0.5rem;">Remove</button>
          </div>
        `;
      });
      container.innerHTML = html;
    }
  }
}

// --- SEARCH LOGIC ---
window.demoSearch = function(event) {
  const q = event.target.value.toLowerCase();
  const resultsBox = document.getElementById('demo-search-results');
  
  if(!q) {
    resultsBox.style.display = 'none';
    return;
  }
  
  const matches = DEMO_PRODUCTS.filter(p => p.title.toLowerCase().includes(q));
  
  if(matches.length > 0) {
    let html = '<div style="padding: 1rem; background: #fff; box-shadow: 0 4px 12px rgba(0,0,0,0.1); border-radius: 4px; position: absolute; top: 100%; left: 0; right: 0; z-index: 1000; max-height: 400px; overflow-y: auto;">';
    matches.forEach(m => {
      html += `
        <div onclick="openSpaPDP(null, '${m.title.replace(/'/g, "\\'")}', '${m.price}', '', '${m.img}')" style="display: flex; gap: 1rem; align-items: center; padding: 0.5rem 0; border-bottom: 1px solid #eee; cursor: pointer;">
          <h4 style="margin: 0; font-size: 0.9rem; color: #2D162C;">${m.title}</h4>
        </div>
      `;
    });
    html += '</div>';
    resultsBox.innerHTML = html;
    resultsBox.style.display = 'block';
  } else {
    resultsBox.innerHTML = '<div style="padding: 1rem; background: #fff; box-shadow: 0 4px 12px rgba(0,0,0,0.1); border-radius: 4px; position: absolute; top: 100%; left: 0; right: 0; z-index: 1000;">No products found.</div>';
    resultsBox.style.display = 'block';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if(typeof updateCartUI === 'function') updateCartUI();
  if(typeof updateWishlistUI === 'function') updateWishlistUI();
});
// Add to the end of assets/demo-engine.js

// Patching updateWishlistUI to also update the bubble
const originalUpdateWishlistUI = window.updateWishlistUI;
window.updateWishlistUI = function() {
  if(originalUpdateWishlistUI) originalUpdateWishlistUI();
  
  const list = getWishlist();
  document.querySelectorAll('.wishlist-count-bubble').forEach(el => {
    el.innerText = list.length;
    el.style.display = list.length > 0 ? 'flex' : 'none';
  });
}
